import { render, staticRenderFns } from "./NotesOnContactPage.vue?vue&type=template&id=fe0fd002"
import script from "./NotesOnContactPage.vue?vue&type=script&lang=js"
export * from "./NotesOnContactPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports